import { withTranslation } from 'react-i18next'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { Button, Typography, List, ListItem, ListItemText, Grid, Box, Divider } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { exportCSVFile, formatHistory } from 'api/fieldNotebooks'

import '../../../styles.css'

const handleExportCSV = (historySelected) => {
  var date = new Date()
  exportCSVFile(formatHistory(historySelected), date.toLocaleDateString())
}

function HistoricItemsContents({
  classes,
  formTitle,
  setHistorySelected,
  historySelected,
  setIsHistoricFormSelected,
  t
}) {
  const handleClick = () => {
    setHistorySelected()
    setIsHistoricFormSelected(false)
  }
  return (
    <>
      <Grid item sm={12} xs={12}>
        <Typography variant='caption'>
          {t('historic_annotation')}
        </Typography>
      </Grid>
      <Grid item sm={12} xs={12} className={classes.page__title}>
        <Box className={classes.Box_buttons}>
          <Button
            variant='outlined'
            color='primary'
            onClick={() => handleClick()}
          >
            <ArrowBackIcon color='primary' className='left_arrow' />
            {t('back')}
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => handleExportCSV(historySelected)}
          >
            {t('download_csv')}
          </Button>
        </Box>
        <Grid item sm={12} xs={12}>
          <Typography className='archive_name'>
            {formTitle}
          </Typography>
        </Grid>
        {!historySelected.length ? (
          <p className='message_no_answer'>{t('no_answer')}</p>
        ) : (
          <List className={classes.List__root}>
            {historySelected.map((rec, index) => <Grid item sm={12} xs={12} key={index} className='container'>
              <ListItem alignItems='flex-start' className='container_list'>
                <FiberManualRecordIcon color={'primary'} className={classes.ellipse} />
                <ListItemText
                  className={classes.Lista__root_item2}
                  primary={rec.form_date}
                  secondary={
                    <>
                      <Grid container spacing={2} className='container_answers'>
                        {rec.answers.map(answer => (
                          <Grid item xs={12} sm={4} md={3}>
                            <Typography className='question_item'>{answer.question}</Typography>
                            <Typography className='answer_item'>{answer.answer}</Typography>
                          </Grid>
                        ))}
                      </Grid>
                      <Divider variant='fullWidth' component='li' />
                    </>
                  }
                />
              </ListItem>
            </Grid>)}
          </List>
        )}
      </Grid>
    </>
  )
}

export default withTranslation()(HistoricItemsContents)